export default "__VITE_ASSET__B1hUO0S2__"